<template>
  <div class="layout-product-question">
    <div class="has-icon-left">
      <div class="round">
        <img class="abs" style="object-fit: cover;" :src="image" alt="Сложный выбор" title="Сложный выбор" />
      </div>
      <div>
        <div class="s-20 w-600"><div>Сложный выбор?</div></div>
        <div class="s-14"><div>Наши дружелюбные сотрудники помогут вам с выбором по телефону или лично в магазине</div></div>
      </div>
    </div>
    <div class="buttons s-18 w-600">
      <div @click="opened = true" style="cursor: pointer">Позвонить нам</div>
      <a @click="ym(96661859,'reachGoal','address_click');" href="/contacts/">Найти магазин</a>
    </div>
    <!--  -->
    <layout-popup v-model="opened" :sended="sended">
      <div class="s-30 w-500">Мы поможем с выбором</div>
      <div class="s-16 opacity-80">Просто оставьте ваши данные, мы перезвоним</div>
      <template slot="form">
        <input required placeholder="Как Вас зовут" v-model="name" name="name" type="text" class="ui-input" />
        <input required placeholder="your_email@example.com" type="email" v-model="email" name="email" class="ui-input" />
        <input @focus="errorBorder" v-model="phone" class="ui-input" type="tel" placeholder="Введите телефон" required />
<!--        <phone-mask-input
            v-model="phone"
            autoDetectCountry
            @onValidate="onValidate"
            inputClass="ui-input"
            placeholder=""
            required
        />-->
<!--        <input required placeholder="+7 (000) 000 00 00" type="phone" v-model="phone" name="phone" class="ui-input" />-->

        <ui-button style="margin-top: 2em;" @click="sendFeedback">Оставить заявку</ui-button>
      </template>
      <div slot="suffix" class="s-12">
        Оставляя Ваш email, вы соглашаетесь с политикой обработки персональных данных
      </div>
      <div slot="suffix" class="socials">
        <div style="cursor: pointer" @click="alloPhone">
          <div>
            <div class="icon"><icon-call></icon-call></div>
          </div>
          <span class="s-12 dashed">Позвонить</span>
        </div>
        <div style="cursor: pointer" @click="alloWhatsapp">
          <div>
            <div class="icon"><icon-whatsapp></icon-whatsapp></div>
          </div>
          <span class="s-12 dashed">Whatsapp</span>
        </div>
        <div style="cursor: pointer" @click="alloTelegram">
          <div>
            <div class="icon"><icon-telegram></icon-telegram></div>
          </div>
          <span class="s-12 dashed">Telegram</span>
        </div>
      </div>
    </layout-popup>
  </div>
</template>

<script>
import PhoneMaskInput from  "vue-phone-mask-input";
export default {
  data() {
    return {
      opened: false,
      sended: false,
      name: "",
      email: "",
      phone: "",
      validPhone: false,
    }
  },
  props: {
    image: {
      type: String,
      required: true
    }
  },
  components: {
    PhoneMaskInput,
    'ui-button': () => import('@/components/ui/ui-button.vue'),
    'layout-popup': () => import('@/components/layout/layout-popup'),
    'icon-call': () => import('@/components/icon/icon-call'),
    'icon-whatsapp': () => import('@/components/icon/icon-call'),
    'icon-telegram': () => import('@/components/icon/icon-telegram')
  },
  methods: {
    alloPhone(){
      if (typeof (ym) === "function") {
        let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
        ym(yaCounterId2, 'reachGoal', 'messenger');
        ym(yaCounterId2, 'reachGoal', 'all_forms');
      }
      setTimeout(() => {
        location.href="tel:"+this.$store.state.langs.TEL_CITY_VIEW_NUM;
      }, 1000)
    },
    alloWhatsapp(){
      if (typeof (ym) === "function") {
        let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
        ym(yaCounterId2, 'reachGoal', 'messenger');
        ym(yaCounterId2, 'reachGoal', 'all_forms');
      }
      setTimeout(() => {
        window.open("https://wa.me/"+this.$store.state.langs.WHTHSAPP);
        //location.href="https://wa.me/"+this.$store.state.langs.WHTHSAPP;
      }, 1000)
    },
    alloTelegram(){
      if (typeof (ym) === "function") {
        let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
        ym(yaCounterId2, 'reachGoal', 'messenger');
        ym(yaCounterId2, 'reachGoal', 'all_forms');
      }
      setTimeout(() => {
        window.open("https://t.me/"+this.$store.state.langs.TELEGRAM);
        //location.href="https://t.me/"+this.$store.state.langs.TELEGRAM;
      }, 1000)
    },
    onValidate(ev){
      this.validPhone = !!ev.isValidByLibPhoneNumberJs;
    },
    sendFeedback() {
      /*if( !this.validPhone ){return false;}*/
      //this.loading = true;
      let inputTelVal = this.phone.replace(/^\D+/g, '').replace(/[^0-9]/g, '');
      const PHONE_REGEXP = /^\d+$/;
      const prone = PHONE_REGEXP.test(inputTelVal);
      if( !prone || ( typeof inputTelVal.length === "undefined" ||  inputTelVal.length < 7) ){
        document.querySelector('input[type="tel"]').classList.add('error');
        return false;
      } else {
        document.querySelector('input[type="tel"]').classList.remove('error');
      }
      this.$axios({
        url: '/ajax/?feadback=Y',
        method: 'post',
        params: {
          name: this.name,
          email: this.email,
          phone: this.phone,
          text: "Сложный выбор, нужна помощь",
          header: "Сложный выбор, нужна помощь",
          url: location.href
        }
      }).then(response => {
        if (response.status == 200 && response.data.success) {
          this.sended=true;
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'help_request_sentForm');

            let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
            ym(yaCounterId2, 'reachGoal', 'call_us');
            ym(yaCounterId2, 'reachGoal', 'all_forms');
          }
         //console.log( "response", response );
        }else{
          console.log('Error feedback success: false')
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
      //this.loading = false;
    },
    errorBorder(){
      const phoneError = document.querySelector('input[type="tel"]');
      if(phoneError) {
        phoneError.classList.remove('error');
      }
    }
  },
  created () {
    this.$bus.$on('updateSended', () => {
      this.sended = false;
    });
  }
}
</script>

<style lang="scss" scoped>
.layout-product-question {
  background: #ffffff;
  box-shadow: 0px 1px 21px rgba(0, 0, 0, 0.16);
  border-radius: 6px;
  margin-top: 2em;
}
.round {
  background: #ccc;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: 1em;
}
.has-icon-left {
  padding: 1.25em;
}
.buttons {
  display: flex;
  & > * {
    flex-grow: 1;
    text-align: center;
    padding: 0.5em 0;
    position: relative;
    &:not(:last-child):after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate(0, -50%);
      height: 1em;
      background: currentColor;
      width: 1px;
      opacity: 0.3;
    }
  }
}
.socials {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2em;
  & > * {
    margin: 0.5em 1em;
  }
}
.icon {
  width: 40px;
  height: 40px;
  background: var(--color);
  border-radius: 50%;
  border-bottom-left-radius: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
</style>
